@if (control) {
  <div class="u-relative">
    @if (config.icon && !config.isIconRight) {
      <div class="form-control__icon">
        <icon [name]="config.icon" [config]="{ fill: 'fc-icon-color' }"> </icon>
      </div>
    }
    <!--
    Custom input option is exposed to allow higher-level components access to the native input element
    while preserving reusability of form-control components label/error/etc. templating.
    Examples include custom form components that implement ControlValueAccessor that need the native input
    -->
    @if (customInputTemplate) {
      <ng-container *ngTemplateOutlet="customInputTemplate"></ng-container>
    } @else {
      @if (!config.mask) {
        <input
          class="form-control"
          [ngClass]="{
            'form-control--icon-right': config.isIconRight,
          }"
          tabindex="0"
          (focusout)="focusOutEvent.emit($event)"
          (focus)="focusEvent.emit($event)"
          #input
          ngDefaultControl
          (keydown)="
            (config.type === 'number'
              ? $event.key !== 'e' && $event.key !== 'E'
              : true)
          "
          [attr.disabled]="isDisabled || null"
          [attr.readonly]="
            config.readonly || disableIfNotRequired(control) || null
          "
          [attr.aria-label]="config.ariaLabel"
          [attr.aria-invalid]="
            (control.dirty || control.touched) && !control.valid
          "
          [attr.aria-describedby]="(config?.id || config?.prop) + '-label'"
          [attr.aria-errormessage]="
            'error_' + (config?.id || config?.prop) + '-input'
          "
          [attr.aria-required]="
            config?.validators && config?.validators.includes('required')
              ? true
              : false
          "
          [attr.autocomplete]="autocomplete !== null ? autocomplete : true"
          [attr.placeholder]="config.placeholder ? config.placeholder : null"
          [attr.type]="config.type"
          [attr.max]="
            config.type === 'date' ? config.max || '9999-01-01' : null
          "
          [attr.min]="config.type === 'date' ? config.min || '' : null"
          [formControl]="control"
          [id]="config.id || config.prop"
          [maxlength]="config.maxLength || ''"
          [name]="config.prop || config.name"
          (input)="onInputChange()"
          [attr.data-test-id]="
            'input_' + (config.id || config.prop || config.ariaLabel)
          "
        />
      } @else {
        @if (config.type === 'datePicker') {
          <zip-date-picker
            [config]="config"
            [control]="control"
          ></zip-date-picker>
        } @else {
          <input
            class="form-control"
            [ngClass]="{
              'form-control--icon-right': config.isIconRight,
            }"
            tabindex="0"
            (focusout)="focusOutEvent.emit($event)"
            (focus)="focusEvent.emit($event)"
            #input
            [zipMask]="config.mask"
            [attr.disabled]="isDisabled || null"
            [attr.readonly]="
              config.readonly || disableIfNotRequired(control) || null
            "
            [attr.aria-label]="config.ariaLabel"
            [attr.aria-invalid]="
              (control.dirty || control.touched) && !control.valid
            "
            [attr.aria-describedby]="(config?.id || config?.prop) + '-label'"
            [attr.aria-errormessage]="
              'error_' + (config?.id || config?.prop) + '-input'
            "
            [attr.aria-required]="
              config?.validators && config?.validators.includes('required')
                ? true
                : false
            "
            [attr.autocomplete]="
              autocomplete !== null ? autocomplete : config.prop || config.name
            "
            [attr.placeholder]="config.placeholder ? config.placeholder : null"
            [attr.max]="
              config.type === 'date' ? config.max || '9999-01-01' : null
            "
            [attr.type]="config.type"
            [formControl]="control"
            [id]="config.id || config.prop"
            [maxlength]="config.maxLength || ''"
            [name]="config.prop || config.name"
            (input)="onInputChange()"
            [attr.data-test-id]="
              'input_' + (config.id || config.prop || config.ariaLabel)
            "
          />
        }
      }
    }
    @if (config.unit) {
      <div class="form-control__icon form-control__icon--right">
        <p [innerHTML]="config.unit" class="t-data t-alt"></p>
      </div>
    }
    @if (config.isIconRight) {
      <div class="form-control__icon form-control__icon--right">
        <icon
          [name]="config.icon"
          [config]="{ fill: 'fc-icon-color' }"
          (click)="iconRightClicked.emit()"
        >
        </icon>
      </div>
    }
    @if (
      config.remainingCount && config.maxLength > 0 && control.value?.length
    ) {
      <span
        class="form-control-textarea__remaining-characters"
        [attr.data-test-id]="
          'input_' +
          (config.id || config.prop || config.ariaLabel) +
          '_max-len-warning'
        "
      >
        {{ config.maxLength - control.value.length }} characters remaining
      </span>
    }
  </div>
}
